// extracted by mini-css-extract-plugin
export default {"layout":"_0aYKV0G1--StackedCtaLayout_layout__fwFhW","wiggle":"_0aYKV0G1--StackedCtaLayout_wiggle__grjnj","shimmer":"_0aYKV0G1--StackedCtaLayout_shimmer__YUgyR"};